import React from 'react';

import { Block } from '@components/components';
import CentraCategoryPageContext from '@components/contexts/CentraCategoryPageContext';
import { RichText } from '@components/renderers/ContentfulPagesRenderer/components';
import type { OwnProps } from 'StateContainer';

import { ProductGrid, TileMenu } from '../../../components';

import { useProducts } from './hooks/useProducts';

const StateContainer: React.FC<OwnProps> = props => {
  const context = useProducts(props);
  const { error } = context;
  const { categoryPageConfig, uri } = props;

  if (error) {
    return (
      <pre>
        Something went wrong:
        {JSON.stringify(error, null, 2)}
      </pre>
    );
  }

  return (
    <CentraCategoryPageContext.Provider value={{ ...props, ...context }}>
      {(categoryPageConfig?.mainTitle || categoryPageConfig?.description) && (
        <div className="container mb-4 mt-4 lg:mt-8">
          {categoryPageConfig?.mainTitle && (
            <h1 className="mb-0 pb-2 text-2xl uppercase leading-none tracking-normal">
              {categoryPageConfig?.mainTitle}
            </h1>
          )}
          {categoryPageConfig?.description && (
            <div className="prose text-sm text-black">{RichText(JSON.parse(categoryPageConfig.description), true)}</div>
          )}
        </div>
      )}
      <TileMenu uri={uri} />

      <Block width="fullscreen" theme="light">
        <ProductGrid parameters={{ listName: `Category - ${categoryPageConfig?.metaTitle || uri}` }} />
      </Block>
    </CentraCategoryPageContext.Provider>
  );
};

export default StateContainer;
